import React, { useContext, useState } from "react";

import {
  Toolbar,
  IconButton,
  Box,
  Drawer,
  Button,
  Divider,
} from "@material-ui/core";

import MenuIcon from "@material-ui/icons/Menu";
import CloseRoundedIcon from "@material-ui/icons/CloseRounded";
import LanguageRoundedIcon from "@material-ui/icons/LanguageRounded";
import PaletteRoundedIcon from "@material-ui/icons/PaletteRounded";
import MapRoundedIcon from "@material-ui/icons/MapRounded";
import TableChartRoundedIcon from "@material-ui/icons/TableChartRounded";

import { useTranslation } from "react-i18next";
import { Context } from "../store/GlobalStore";
import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";

interface Props {}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    menuButton: {
      margin: "25px 3px",
      width: "250px",
    },
    closeButton: {
      marginLeft: "220px",
      marginTop: "75px",
    },
    image: {
      marginTop: "7px",
    },
    bar: {
      position: "fixed",
      background: theme.palette.background.default,
      zIndex: 2000,
      top: 0,
    },
  })
);
export const UpperToolbar = (props: Props) => {
  const classes = useStyles();
  const [showMenu, setShowMenu] = useState<boolean>(false);
  const toggleMenu = () => {
    setShowMenu(!showMenu);
  };

  const { store, dispatch } = useContext(Context);
  const { t, i18n } = useTranslation();

  const changeTheme = () => {
    dispatch({
      type: "CHANGE_THEME",
      theme: store.theme,
    });
    toggleMenu();
  };

  const changeLanguage = () => {
    if (i18n.language === "sk") {
      i18n.changeLanguage("en");
    } else {
      i18n.changeLanguage("sk");
    }
    toggleMenu();
  };
  return (
    <React.Fragment>
      <Toolbar className={classes.bar}>
        <Box
          display="flex"
          justifyContent="space-between"
          width="100%"
          className={classes.bar}
        >
          <IconButton
            edge="start"
            color="inherit"
            aria-label="menu"
            onClick={() => toggleMenu()}
          >
            <MenuIcon fontSize="large" />
          </IconButton>
          <img
            src="signicaLogo.png"
            height="50px"
            className={classes.image}
            alt=""
          />
          <Box width="60px" height="40px" />
        </Box>
      </Toolbar>

      <Drawer anchor="left" open={showMenu} onClose={() => toggleMenu()}>
        <CloseRoundedIcon
          onClick={() => toggleMenu()}
          className={classes.closeButton}
        />

        <Button
          onClick={() => (window.location.href = "/Camera")}
          className={classes.menuButton}
          startIcon={<PaletteRoundedIcon />}
          size="large"
        >
          {t("Add sign")}
        </Button>
        <Button
          onClick={() => (window.location.href = "/SignTable")}
          className={classes.menuButton}
          startIcon={<TableChartRoundedIcon />}
          size="large"
        >
          {t("Sing table")}
        </Button>
        <Button
          onClick={() => (window.location.href = "/Map")}
          className={classes.menuButton}
          startIcon={<MapRoundedIcon />}
          size="large"
        >
          {t("Show on map")}
        </Button>
        <Divider />
        <Button
          onClick={() => changeLanguage()}
          className={classes.menuButton}
          startIcon={<LanguageRoundedIcon />}
          size="large"
        >
          {t("Zmeniť jazyk")}
        </Button>
        <Button
          onClick={() => changeTheme()}
          className={classes.menuButton}
          startIcon={<PaletteRoundedIcon />}
          size="large"
        >
          {t("Change theme")}
        </Button>
      </Drawer>
    </React.Fragment>
  );
};
